// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiSpecialtyPharmacy {
    static getAttributeTypeMap() {
        return MedicalBiSpecialtyPharmacy.attributeTypeMap;
    }
}
MedicalBiSpecialtyPharmacy.discriminator = undefined;
MedicalBiSpecialtyPharmacy.additionalProperties = false;
MedicalBiSpecialtyPharmacy.attributeTypeMap = [
    {
        "name": "available",
        "baseName": "available",
        "type": "string"
    },
    {
        "name": "coInsurance",
        "baseName": "coInsurance",
        "type": "string"
    },
    {
        "name": "copay",
        "baseName": "copay",
        "type": "string"
    },
    {
        "name": "exclusions",
        "baseName": "exclusions",
        "type": "string"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiSpecialtyPharmacy.js.map